<div class="jb-max-width center db mv6" *ngIf="content">
  <jb-tabs
    id="first-tab"
    [isDynamicBase]="true"
    [theme]="content.theme"
    [shouldTabToContent]="false"
    (tabSelected)="onTabSelected($event)"
  >
    <div class="w-100">
      <jb-tab-panel
        *ngFor="let pod of content.tabbedNavigationComponent; let i = index"
        [attr.data-order]="i + 1"
        [label]="pod.data?.title"
        [iconName]="
          pod.data?.icon?.length && displayIcons
            ? pod.data?.icon[0].src
            : undefined
        "
      >
        <div class="pt3" *ngIf="pod.data?.tabContent">
          <jb-renderer-template
            *ngIf="pod?.data?.tabContent"
            [components]="pod?.data?.tabContent"
            [registry]="createRegistry(pod?.data?.tabContent)"
            [priority]="'tertiary'"
          ></jb-renderer-template>
        </div>
      </jb-tab-panel>
    </div>
  </jb-tabs>
</div>
